module.exports = __webpack_public_path__ + "img/Banner chico 1.ffb62bf4.png";